<div class="row row--guttered-h" *ngIf="options">
    <highcharts-chart [ngClass]="chartType != 'sleep-stages-proba' ? 'graph' : 'discreteGraph'"
                      [Highcharts]="Highcharts"
                      [callbackFunction]="chartCallback"
                      [options]="options">
    </highcharts-chart>
</div>
